"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSetService = void 0;
var constants_1 = require("../constants");
var standard_set_global_id_enum_1 = require("../constants/standard-set-global-id.enum");
var standard_set_model_1 = require("../models/settings/standard-set.model");
var defaultStandardSets = [
    new standard_set_model_1.StandardSet({
        code: 'CCSS',
        name: 'Common Core State Standards',
    }),
];
/**
 * Service to retrieve the standard sets.
 *
 * At this point it returns mocked data.
 */
var StandardSetService = /** @class */ (function () {
    function StandardSetService() {
    }
    /**
     * It returns all the standard sets
     */
    StandardSetService.prototype.findAll = function () {
        return defaultStandardSets;
    };
    StandardSetService.prototype.findStandardSetGlobalIdByCurriculum = function (curriculum) {
        switch (curriculum) {
            case constants_1.CurriculumId.EurekaMath:
            case constants_1.CurriculumId.WitAndWisdom:
                return standard_set_global_id_enum_1.StandardSetGlobalId.CommonCore;
            case constants_1.CurriculumId.EurekaMathTX:
                return standard_set_global_id_enum_1.StandardSetGlobalId.TX;
            default:
                return standard_set_global_id_enum_1.StandardSetGlobalId.CommonCore;
        }
    };
    return StandardSetService;
}());
exports.StandardSetService = StandardSetService;
